export default __webpack_public_path__ + "static/media/pic4.d8890e71.jpg";